import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Global from '../../store/global-selectors';
import { CustomsService } from '../../services/customs-service';
import * as CustomsDeclarationsActions from '../../store/customs-declarations/customs-declarations.actions';

export const useCustomsState = (fulfillmentPlanId, onConfigurationChange) => {
  const defaultCountryCode = useSelector(Global.selectSellerHomeCountry);
  const defaultWeightUnit = useSelector(Global.selectSellerDefaultWeightUnit);
  const defaultCurrencyCode = useSelector(Global.selectSellerDefaultCurrency) || 'USD';
  const defaultCustomsValues = useSelector(Global.selectSellerDefaultCustomData);

  const dispatch = useDispatch();

  const onCustomsChange = useCallback(
    (newCustoms, needsCustoms) => {
      const sanitizedCustoms = {
        ...newCustoms,
        customsItems: newCustoms.customsItems.map((item) => ({
          ...item,
          quantity: Number.parseFloat(item.quantity || '0'),
          unitPrice: {
            ...item.unitPrice,
            value: item.unitPrice.value ? Number.parseFloat(item.unitPrice.value || '0') : undefined,
          },
        })),
      };
      const validatedCustoms = CustomsService.validateCustoms(sanitizedCustoms, defaultCountryCode, defaultCurrencyCode, defaultWeightUnit);
      const finalizedCustoms = CustomsService.fillCustomsWithDefaults(
        validatedCustoms,
        defaultCustomsValues,
        defaultCurrencyCode,
        defaultWeightUnit,
      );

      dispatch(CustomsDeclarationsActions.validateCustomsAndSave(fulfillmentPlanId, finalizedCustoms, needsCustoms));
      onConfigurationChange({
        customs: finalizedCustoms,
      });
    },
    [dispatch, defaultCurrencyCode, defaultCustomsValues, defaultCountryCode, defaultWeightUnit, fulfillmentPlanId, onConfigurationChange],
  );
  return {
    onCustomsChange,
  };
};
